// demoStoresData.js
// Complete catalogue of 100+ ready-to-use business websites for the Ownezzy Mobile App & Store Launcher.
// Pricing: 7-Day Free Trial, then ₹399/month (or ₹4,499/year). 0% Commission.

export const CATEGORY_FILTERS = [
  { id: 'all', label: 'All Websites (100+)', icon: '✨' },
  { id: 'fashion', label: 'Clothing & Fashion', icon: '👗', matches: ['clothing', 'beauty', 'kurti', 'blouses', 'pattu', 'linens', 'tshirts', 'sarees', 'dailywear', 'jewellery', 'bangles', 'artjewellery'] },
  { id: 'plants', label: 'Plants & Garden', icon: '🌱', matches: ['plants', 'gardentools'] },
  { id: 'gifts', label: 'Gifts & Favors', icon: '🎁', matches: ['gifts', 'favors', 'resin', 'crochet', 'acrylic', 'comics', 'wallclocks', 'candles'] },
  { id: 'tech', label: 'Phone Cases & Tech', icon: '📱', matches: ['tech', 'electronics'] },
  { id: 'footwear', label: 'Footwear & Juttis', icon: '👡', matches: ['footwear'] },
  { id: 'bags', label: 'Bags & Totes', icon: '👜', matches: ['bags'] },
  { id: 'crafts', label: 'Resin Crafts & Art', icon: '🧵', matches: ['crafts', 'resin', 'crochet'] },
  { id: 'decor', label: 'Home Decor & Urulis', icon: '🕯️', matches: ['decor', 'uruli', 'linens', 'acrylic', 'pooja', 'wallclocks', 'mirrors', 'cleaning', 'candles'] },
  { id: 'wellness', label: 'Beauty & Skincare', icon: '💄', matches: ['beauty', 'cosmetics', 'perfume', 'wellness', 'herbal', 'jewellery', 'bangles', 'artjewellery', 'coconutoil'] },
  { id: 'food', label: 'Grocery, Spices & Dry Fruits', icon: '🛒', matches: ['grocery', 'fresh', 'spices', 'dryfruits', 'organic', 'snacks', 'teacoffee', 'pickles', 'sweets', 'healthmix', 'bakery', 'tiffin', 'coconutoil'] },
  { id: 'toys', label: 'Toys & Kids', icon: '🧸', matches: ['toys', 'pattu'] },
  { id: 'health', label: 'Medical & Health', icon: '🩺', matches: ['medcare', 'organic'] },
  { id: 'textiles', label: 'Towels, Lungis & Linen', icon: '🧣', matches: ['bedbath', 'lungi', 'linens'] },
  { id: 'murti', label: 'Murtis & Pooja', icon: '🛕', matches: ['murti', 'uruli'] },
  { id: 'pets', label: 'Pet Store', icon: '🐾', matches: ['pets', 'aquarium'] },
  { id: 'intl', label: 'International Stores (20)', icon: '🌍' },
];

export const PRICING_CONFIG = {
  monthly: 399,
  yearly: 4499,
  trialDays: 7,
  commission: '0%',
  label: '₹399 / month',
  badge: '7-Day Free Trial',
  tagline: '7-Day Free Trial • Then ₹399/month • 0% Commission',
  features: [
    'Complete store website + mobile app + admin panel',
    'Free subdomain (shopname.ownezzy.com) & SSL included',
    'Custom domain support (yourshop.com)',
    'Direct customer UPI (PhonePe, GPay, Paytm) with 0% fee',
    'Cash on delivery (COD) support',
    'Automated WhatsApp & Email order receipts',
    'Unlimited products, categories & orders',
    'Search engine ready (Google SEO)',
  ],
};

export const DEMO_STORES = [
  {
    "id": "clothing",
    "baseId": "clothing",
    "template": "clothing",
    "name": "UrbanThread",
    "label": "Clothing Store",
    "icon": "👗",
    "note": "Kurtis, sarees, salwar suits, lehengas and co-ords, with sizes and colours.",
    "business": "clothing business",
    "demo": "fashion",
    "url": "https://fashion.ownezzy.com",
    "pitch": "Sell kurtis, sarees and fashion online",
    "preview": "https://ownezzy.com/previews/clothing-480.webp?v=8",
    "theme": {
      "main": "#d6336c",
      "soft": "#fde8ef",
      "warm": "#fff1e6"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "clothing-v2",
    "baseId": "clothing",
    "template": "clothing",
    "layout": "v2",
    "name": "UrbanThread Studio",
    "label": "Clothing Store v2",
    "icon": "👗",
    "note": "Kurtis, sarees, salwar suits, lehengas and co-ords, with sizes and colours. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "clothing business",
    "demo": "fashion-v2",
    "url": "https://fashion-v2.ownezzy.com",
    "pitch": "Sell kurtis, sarees and fashion online (Studio design)",
    "preview": "https://ownezzy.com/previews/clothing-v2-480.webp?v=8",
    "theme": {
      "main": "#d6336c",
      "soft": "#fde8ef",
      "warm": "#fff1e6"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "beauty",
    "baseId": "beauty",
    "template": "beauty",
    "name": "Luxe Muse",
    "label": "Fashion & Beauty",
    "icon": "💖",
    "note": "Western wear, ethnic wear, makeup, skincare and fragrances in one modern store.",
    "business": "fashion & beauty business",
    "demo": "beauty",
    "url": "https://beauty.ownezzy.com",
    "pitch": "Sell fashion, makeup, skincare & fragrances online",
    "preview": "https://ownezzy.com/previews/beauty-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fdf2f8"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "beauty-v2",
    "baseId": "beauty",
    "template": "beauty",
    "layout": "v2",
    "name": "Luxe Muse Studio",
    "label": "Fashion & Beauty v2",
    "icon": "💖",
    "note": "Western wear, ethnic wear, makeup, skincare and fragrances in one modern store. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "fashion & beauty business",
    "demo": "beauty-v2",
    "url": "https://beauty-v2.ownezzy.com",
    "pitch": "Sell fashion, makeup, skincare & fragrances online (Studio design)",
    "preview": "https://ownezzy.com/previews/beauty-v2-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fdf2f8"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "cosmetics",
    "baseId": "cosmetics",
    "template": "cosmetics",
    "name": "GlowLab",
    "label": "Cosmetics Brand",
    "icon": "💄",
    "note": "Lipsticks, foundations, eyeshadow palettes, nail colours and serums for your own makeup brand.",
    "business": "cosmetics & makeup brand",
    "demo": "cosmetics",
    "url": "https://cosmetics.ownezzy.com",
    "pitch": "Launch your cosmetics & makeup brand online",
    "preview": "https://ownezzy.com/previews/cosmetics-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#fce7f3",
      "warm": "#fdf2f8"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "cosmetics-v2",
    "baseId": "cosmetics",
    "template": "cosmetics",
    "layout": "v2",
    "name": "GlowLab Studio",
    "label": "Cosmetics Brand v2",
    "icon": "💄",
    "note": "Lipsticks, foundations, eyeshadow palettes, nail colours and serums for your own makeup brand. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "cosmetics & makeup brand",
    "demo": "cosmetics-v2",
    "url": "https://cosmetics-v2.ownezzy.com",
    "pitch": "Launch your cosmetics & makeup brand online (Studio design)",
    "preview": "https://ownezzy.com/previews/cosmetics-v2-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#fce7f3",
      "warm": "#fdf2f8"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "kurti",
    "baseId": "kurti",
    "template": "kurti",
    "name": "KurtiKraft",
    "label": "Customised Kurtis",
    "icon": "🧵",
    "note": "Made-to-measure kurtis with a live design studio: colour, neck, sleeves, length and print.",
    "business": "custom kurti & tailoring business",
    "demo": "kurti",
    "url": "https://kurti.ownezzy.com",
    "pitch": "Sell custom-stitched kurtis with a live design studio",
    "preview": "https://ownezzy.com/previews/kurti-480.webp?v=8",
    "theme": {
      "main": "#c026d3",
      "soft": "#fae8ff",
      "warm": "#fdf4ff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "kurti-v2",
    "baseId": "kurti",
    "template": "kurti",
    "layout": "v2",
    "name": "KurtiKraft Studio",
    "label": "Customised Kurtis v2",
    "icon": "🧵",
    "note": "Made-to-measure kurtis with a live design studio: colour, neck, sleeves, length and print. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "custom kurti & tailoring business",
    "demo": "kurti-v2",
    "url": "https://kurti-v2.ownezzy.com",
    "pitch": "Sell custom-stitched kurtis with a live design studio (Studio design)",
    "preview": "https://ownezzy.com/previews/kurti-v2-480.webp?v=8",
    "theme": {
      "main": "#c026d3",
      "soft": "#fae8ff",
      "warm": "#fdf4ff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "perfume",
    "baseId": "perfume",
    "template": "perfume",
    "name": "ScentStory",
    "label": "Perfumes & Name Soaps",
    "icon": "🌸",
    "note": "Men's and women's perfumes, pure attars, name-engraved soaps and gift sets with a live soap design studio.",
    "business": "perfume, attar & custom soap business",
    "demo": "perfume",
    "url": "https://perfume.ownezzy.com",
    "pitch": "Sell perfumes, attars & name-engraved soaps online",
    "preview": "https://ownezzy.com/previews/perfume-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#fdf2f8"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "perfume-v2",
    "baseId": "perfume",
    "template": "perfume",
    "layout": "v2",
    "name": "ScentStory Studio",
    "label": "Perfumes & Name Soaps v2",
    "icon": "🌸",
    "note": "Men's and women's perfumes, pure attars, name-engraved soaps and gift sets with a live soap design studio. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "perfume, attar & custom soap business",
    "demo": "perfume-v2",
    "url": "https://perfume-v2.ownezzy.com",
    "pitch": "Sell perfumes, attars & name-engraved soaps online (Studio design)",
    "preview": "https://ownezzy.com/previews/perfume-v2-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#fdf2f8"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "toys",
    "baseId": "toys",
    "template": "toys",
    "name": "ToyBazaar",
    "label": "Wholesale Toys",
    "icon": "🧸",
    "note": "Soft toys, die-cast cars, puzzles, dolls and ride-ons in wholesale packs with GST bills.",
    "business": "wholesale toy business",
    "demo": "toys",
    "url": "https://toys.ownezzy.com",
    "pitch": "Sell toys wholesale online",
    "preview": "https://ownezzy.com/previews/toys-480.webp?v=8",
    "theme": {
      "main": "#f97316",
      "soft": "#ffedd5",
      "warm": "#fef9c3"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "toys-v2",
    "baseId": "toys",
    "template": "toys",
    "layout": "v2",
    "name": "ToyBazaar Studio",
    "label": "Wholesale Toys v2",
    "icon": "🧸",
    "note": "Soft toys, die-cast cars, puzzles, dolls and ride-ons in wholesale packs with GST bills. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "wholesale toy business",
    "demo": "toys-v2",
    "url": "https://toys-v2.ownezzy.com",
    "pitch": "Sell toys wholesale online (Studio design)",
    "preview": "https://ownezzy.com/previews/toys-v2-480.webp?v=8",
    "theme": {
      "main": "#f97316",
      "soft": "#ffedd5",
      "warm": "#fef9c3"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "medcare",
    "baseId": "medcare",
    "template": "medcare",
    "name": "MedCare Plus",
    "label": "Medical & Health",
    "icon": "🩺",
    "note": "BP monitors, oximeters, thermometers, first aid, vitamins and mobility aids.",
    "business": "medical & healthcare products business",
    "demo": "medcare",
    "url": "https://medcare.ownezzy.com",
    "pitch": "Sell medical and health products online",
    "preview": "https://ownezzy.com/previews/medcare-480.webp?v=8",
    "theme": {
      "main": "#0284c7",
      "soft": "#e0f2fe",
      "warm": "#ccfbf1"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "medcare-v2",
    "baseId": "medcare",
    "template": "medcare",
    "layout": "v2",
    "name": "MedCare Plus Studio",
    "label": "Medical & Health v2",
    "icon": "🩺",
    "note": "BP monitors, oximeters, thermometers, first aid, vitamins and mobility aids. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "medical & healthcare products business",
    "demo": "medcare-v2",
    "url": "https://medcare-v2.ownezzy.com",
    "pitch": "Sell medical and health products online (Studio design)",
    "preview": "https://ownezzy.com/previews/medcare-v2-480.webp?v=8",
    "theme": {
      "main": "#0284c7",
      "soft": "#e0f2fe",
      "warm": "#ccfbf1"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "dryfruits",
    "baseId": "dryfruits",
    "template": "dryfruits",
    "name": "NuttyGrove",
    "label": "Dry Fruits & Nuts",
    "icon": "🥜",
    "note": "Cashews, almonds, pistachios, dates, figs and festive dry fruit gift boxes.",
    "business": "dry fruits business",
    "demo": "dryfruits",
    "url": "https://dryfruits.ownezzy.com",
    "pitch": "Sell dry fruits and gift boxes online",
    "preview": "https://ownezzy.com/previews/dryfruits-480.webp?v=8",
    "theme": {
      "main": "#b45309",
      "soft": "#fef3c7",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "dryfruits-v2",
    "baseId": "dryfruits",
    "template": "dryfruits",
    "layout": "v2",
    "name": "NuttyGrove Studio",
    "label": "Dry Fruits & Nuts v2",
    "icon": "🥜",
    "note": "Cashews, almonds, pistachios, dates, figs and festive dry fruit gift boxes. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "dry fruits business",
    "demo": "dryfruits-v2",
    "url": "https://dryfruits-v2.ownezzy.com",
    "pitch": "Sell dry fruits and gift boxes online (Studio design)",
    "preview": "https://ownezzy.com/previews/dryfruits-v2-480.webp?v=8",
    "theme": {
      "main": "#b45309",
      "soft": "#fef3c7",
      "warm": "#fff7ed"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bedbath",
    "baseId": "bedbath",
    "template": "bedbath",
    "name": "SoftNest",
    "label": "Towels & Bed Linen",
    "icon": "🛁",
    "note": "Cotton bath towels, bedsheets, pillows, comforters and bathrobes for homes and hotels.",
    "business": "towel & bed linen business",
    "demo": "bedbath",
    "url": "https://bedbath.ownezzy.com",
    "pitch": "Sell towels, bedsheets and bathrobes online",
    "preview": "https://ownezzy.com/previews/bedbath-480.webp?v=8",
    "theme": {
      "main": "#0369a1",
      "soft": "#e0f2fe",
      "warm": "#f0f9ff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bedbath-v2",
    "baseId": "bedbath",
    "template": "bedbath",
    "layout": "v2",
    "name": "SoftNest Studio",
    "label": "Towels & Bed Linen v2",
    "icon": "🛁",
    "note": "Cotton bath towels, bedsheets, pillows, comforters and bathrobes for homes and hotels. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "towel & bed linen business",
    "demo": "bedbath-v2",
    "url": "https://bedbath-v2.ownezzy.com",
    "pitch": "Sell towels, bedsheets and bathrobes online (Studio design)",
    "preview": "https://ownezzy.com/previews/bedbath-v2-480.webp?v=8",
    "theme": {
      "main": "#0369a1",
      "soft": "#e0f2fe",
      "warm": "#f0f9ff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "lungi",
    "baseId": "lungi",
    "template": "lungi",
    "name": "LungiGhar",
    "label": "Gamcha, Lungi & Dhoti",
    "icon": "🧣",
    "note": "Pure cotton gamchas, check lungis, dhotis, mundus and thorthu towels, retail and wholesale.",
    "business": "gamcha & lungi business",
    "demo": "lungi",
    "url": "https://lungi.ownezzy.com",
    "pitch": "Sell gamchas, lungis and dhotis online",
    "preview": "https://ownezzy.com/previews/lungi-480.webp?v=8",
    "theme": {
      "main": "#b91c1c",
      "soft": "#fee2e2",
      "warm": "#dbeafe"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "lungi-v2",
    "baseId": "lungi",
    "template": "lungi",
    "layout": "v2",
    "name": "LungiGhar Studio",
    "label": "Gamcha, Lungi & Dhoti v2",
    "icon": "🧣",
    "note": "Pure cotton gamchas, check lungis, dhotis, mundus and thorthu towels, retail and wholesale. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "gamcha & lungi business",
    "demo": "lungi-v2",
    "url": "https://lungi-v2.ownezzy.com",
    "pitch": "Sell gamchas, lungis and dhotis online (Studio design)",
    "preview": "https://ownezzy.com/previews/lungi-v2-480.webp?v=8",
    "theme": {
      "main": "#b91c1c",
      "soft": "#fee2e2",
      "warm": "#dbeafe"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "organic",
    "baseId": "organic",
    "template": "organic",
    "name": "PureEarth Organics",
    "label": "Organic Products",
    "icon": "🌿",
    "note": "Organic grains, cold-pressed oils, raw honey, jaggery and herbal teas.",
    "business": "organic food business",
    "demo": "organic",
    "url": "https://organic.ownezzy.com",
    "pitch": "Sell organic food and wellness products online",
    "preview": "https://ownezzy.com/previews/organic-480.webp?v=8",
    "theme": {
      "main": "#15803d",
      "soft": "#dcfce7",
      "warm": "#ecfccb"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "organic-v2",
    "baseId": "organic",
    "template": "organic",
    "layout": "v2",
    "name": "PureEarth Organics Studio",
    "label": "Organic Products v2",
    "icon": "🌿",
    "note": "Organic grains, cold-pressed oils, raw honey, jaggery and herbal teas. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "organic food business",
    "demo": "organic-v2",
    "url": "https://organic-v2.ownezzy.com",
    "pitch": "Sell organic food and wellness products online (Studio design)",
    "preview": "https://ownezzy.com/previews/organic-v2-480.webp?v=8",
    "theme": {
      "main": "#15803d",
      "soft": "#dcfce7",
      "warm": "#ecfccb"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "murti",
    "baseId": "murti",
    "template": "murti",
    "name": "ShilpKala",
    "label": "Murtis & Sculptures",
    "icon": "🛕",
    "note": "Ganesha, Buddha, Radha Krishna and Durga murtis in stone, marble, brass and clay.",
    "business": "murti & sculpture business",
    "demo": "murti",
    "url": "https://murti.ownezzy.com",
    "pitch": "Sell murtis, idols and sculptures online",
    "preview": "https://ownezzy.com/previews/murti-480.webp?v=8",
    "theme": {
      "main": "#9a3412",
      "soft": "#ffedd5",
      "warm": "#fef3c7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "murti-v2",
    "baseId": "murti",
    "template": "murti",
    "layout": "v2",
    "name": "ShilpKala Studio",
    "label": "Murtis & Sculptures v2",
    "icon": "🛕",
    "note": "Ganesha, Buddha, Radha Krishna and Durga murtis in stone, marble, brass and clay. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "murti & sculpture business",
    "demo": "murti-v2",
    "url": "https://murti-v2.ownezzy.com",
    "pitch": "Sell murtis, idols and sculptures online (Studio design)",
    "preview": "https://ownezzy.com/previews/murti-v2-480.webp?v=8",
    "theme": {
      "main": "#9a3412",
      "soft": "#ffedd5",
      "warm": "#fef3c7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "spices",
    "baseId": "spices",
    "template": "spices",
    "name": "MasalaMandi",
    "label": "Spices & Masalas",
    "icon": "🌶️",
    "note": "Whole spices, fresh powders and masala blends in packets, jars and bulk.",
    "business": "spices & masala business",
    "demo": "spices",
    "url": "https://spices.ownezzy.com",
    "pitch": "Sell spices and masalas online",
    "preview": "https://ownezzy.com/previews/spices-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#fee2e2"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "spices-v2",
    "baseId": "spices",
    "template": "spices",
    "layout": "v2",
    "name": "MasalaMandi Studio",
    "label": "Spices & Masalas v2",
    "icon": "🌶️",
    "note": "Whole spices, fresh powders and masala blends in packets, jars and bulk. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "spices & masala business",
    "demo": "spices-v2",
    "url": "https://spices-v2.ownezzy.com",
    "pitch": "Sell spices and masalas online (Studio design)",
    "preview": "https://ownezzy.com/previews/spices-v2-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#fee2e2"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "snacks",
    "baseId": "snacks",
    "template": "snacks",
    "name": "CrunchKart",
    "label": "Chips, Fries & Namkeen",
    "icon": "🍟",
    "note": "Potato chips, frozen fries, namkeen, roasted snacks and party packs, retail and wholesale.",
    "business": "chips & namkeen business",
    "demo": "snacks",
    "url": "https://snacks.ownezzy.com",
    "pitch": "Sell chips, namkeen and snacks online",
    "preview": "https://ownezzy.com/previews/snacks-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#ffedd5",
      "warm": "#fef9c3"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "snacks-v2",
    "baseId": "snacks",
    "template": "snacks",
    "layout": "v2",
    "name": "CrunchKart Studio",
    "label": "Chips, Fries & Namkeen v2",
    "icon": "🍟",
    "note": "Potato chips, frozen fries, namkeen, roasted snacks and party packs, retail and wholesale. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "chips & namkeen business",
    "demo": "snacks-v2",
    "url": "https://snacks-v2.ownezzy.com",
    "pitch": "Sell chips, namkeen and snacks online (Studio design)",
    "preview": "https://ownezzy.com/previews/snacks-v2-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#ffedd5",
      "warm": "#fef9c3"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "teacoffee",
    "baseId": "teacoffee",
    "template": "teacoffee",
    "name": "BrewLeaf",
    "label": "Tea & Coffee",
    "icon": "☕",
    "note": "Loose leaf tea, masala chai, roasted coffee beans, brewing gear and tea sets.",
    "business": "tea & coffee business",
    "demo": "teacoffee",
    "url": "https://teacoffee.ownezzy.com",
    "pitch": "Sell tea, coffee and brewing gear online",
    "preview": "https://ownezzy.com/previews/teacoffee-480.webp?v=8",
    "theme": {
      "main": "#78350f",
      "soft": "#fef3c7",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "teacoffee-v2",
    "baseId": "teacoffee",
    "template": "teacoffee",
    "layout": "v2",
    "name": "BrewLeaf Studio",
    "label": "Tea & Coffee v2",
    "icon": "☕",
    "note": "Loose leaf tea, masala chai, roasted coffee beans, brewing gear and tea sets. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "tea & coffee business",
    "demo": "teacoffee-v2",
    "url": "https://teacoffee-v2.ownezzy.com",
    "pitch": "Sell tea, coffee and brewing gear online (Studio design)",
    "preview": "https://ownezzy.com/previews/teacoffee-v2-480.webp?v=8",
    "theme": {
      "main": "#78350f",
      "soft": "#fef3c7",
      "warm": "#fff7ed"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "gardentools",
    "baseId": "gardentools",
    "template": "gardentools",
    "name": "ToolShed",
    "label": "Gardening Tools",
    "icon": "🪴",
    "note": "Hand tools, pruners, hoses, sprinklers and garden kits for homes and farms.",
    "business": "gardening tools business",
    "demo": "gardentools",
    "url": "https://gardentools.ownezzy.com",
    "pitch": "Sell gardening tools online",
    "preview": "https://ownezzy.com/previews/gardentools-480.webp?v=8",
    "theme": {
      "main": "#4d7c0f",
      "soft": "#ecfccb",
      "warm": "#f0fdf4"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "gardentools-v2",
    "baseId": "gardentools",
    "template": "gardentools",
    "layout": "v2",
    "name": "ToolShed Studio",
    "label": "Gardening Tools v2",
    "icon": "🪴",
    "note": "Hand tools, pruners, hoses, sprinklers and garden kits for homes and farms. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "gardening tools business",
    "demo": "gardentools-v2",
    "url": "https://gardentools-v2.ownezzy.com",
    "pitch": "Sell gardening tools online (Studio design)",
    "preview": "https://ownezzy.com/previews/gardentools-v2-480.webp?v=8",
    "theme": {
      "main": "#4d7c0f",
      "soft": "#ecfccb",
      "warm": "#f0fdf4"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pickles",
    "baseId": "pickles",
    "template": "pickles",
    "name": "AmmaRuchi",
    "label": "Pickles, Podis & Masalas",
    "icon": "🥭",
    "note": "Andhra and Tamil pickles, idli podis and homemade masalas in leak-proof jars.",
    "business": "homemade pickles & podi business",
    "demo": "pickles",
    "url": "https://pickles.ownezzy.com",
    "pitch": "Sell homemade pickles and podis online",
    "preview": "https://ownezzy.com/previews/pickles-480.webp?v=8",
    "theme": {
      "main": "#b91c1c",
      "soft": "#fee2e2",
      "warm": "#fef3c7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pickles-v2",
    "baseId": "pickles",
    "template": "pickles",
    "layout": "v2",
    "name": "AmmaRuchi Studio",
    "label": "Pickles, Podis & Masalas v2",
    "icon": "🥭",
    "note": "Andhra and Tamil pickles, idli podis and homemade masalas in leak-proof jars. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "homemade pickles & podi business",
    "demo": "pickles-v2",
    "url": "https://pickles-v2.ownezzy.com",
    "pitch": "Sell homemade pickles and podis online (Studio design)",
    "preview": "https://ownezzy.com/previews/pickles-v2-480.webp?v=8",
    "theme": {
      "main": "#b91c1c",
      "soft": "#fee2e2",
      "warm": "#fef3c7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bakery",
    "baseId": "bakery",
    "template": "bakery",
    "name": "SugarCrumbs",
    "label": "Home Bakery & Cakes",
    "icon": "🎂",
    "note": "Birthday, theme and celebration cakes, cupcakes and cookies with eggless options and message on cake.",
    "business": "home bakery & cake business",
    "demo": "cakes",
    "url": "https://cakes.ownezzy.com",
    "pitch": "Sell custom cakes and bakes online",
    "preview": "https://ownezzy.com/previews/bakery-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fdf2f8"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bakery-v2",
    "baseId": "bakery",
    "template": "bakery",
    "layout": "v2",
    "name": "SugarCrumbs Studio",
    "label": "Home Bakery & Cakes v2",
    "icon": "🎂",
    "note": "Birthday, theme and celebration cakes, cupcakes and cookies with eggless options and message on cake. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "home bakery & cake business",
    "demo": "cakes-v2",
    "url": "https://cakes-v2.ownezzy.com",
    "pitch": "Sell custom cakes and bakes online (Studio design)",
    "preview": "https://ownezzy.com/previews/bakery-v2-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fdf2f8"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "jewellery",
    "baseId": "jewellery",
    "template": "jewellery",
    "name": "Thangam Jewels",
    "label": "Temple & Imitation Jewellery",
    "icon": "💛",
    "note": "Temple, kemp, antique and oxidised jewellery sets, jhumkas and bangles that look like real gold.",
    "business": "imitation jewellery business",
    "demo": "jewellery",
    "url": "https://jewellery.ownezzy.com",
    "pitch": "Sell imitation and temple jewellery online",
    "preview": "https://ownezzy.com/previews/jewellery-480.webp?v=8",
    "theme": {
      "main": "#a16207",
      "soft": "#fef3c7",
      "warm": "#fffbeb"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "jewellery-v2",
    "baseId": "jewellery",
    "template": "jewellery",
    "layout": "v2",
    "name": "Thangam Jewels Studio",
    "label": "Temple & Imitation Jewellery v2",
    "icon": "💛",
    "note": "Temple, kemp, antique and oxidised jewellery sets, jhumkas and bangles that look like real gold. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "imitation jewellery business",
    "demo": "jewellery-v2",
    "url": "https://jewellery-v2.ownezzy.com",
    "pitch": "Sell imitation and temple jewellery online (Studio design)",
    "preview": "https://ownezzy.com/previews/jewellery-v2-480.webp?v=8",
    "theme": {
      "main": "#a16207",
      "soft": "#fef3c7",
      "warm": "#fffbeb"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "sarees",
    "baseId": "sarees",
    "template": "sarees",
    "name": "Kanchi Weaves",
    "label": "Silk & Handloom Sarees",
    "icon": "🥻",
    "note": "Kanchipuram silk, soft silk, handloom cotton and Kerala sarees straight from weavers.",
    "business": "saree business",
    "demo": "sarees",
    "url": "https://sarees.ownezzy.com",
    "pitch": "Sell silk and handloom sarees online",
    "preview": "https://ownezzy.com/previews/sarees-480.webp?v=8",
    "theme": {
      "main": "#7e22ce",
      "soft": "#f3e8ff",
      "warm": "#fdf2f8"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "sarees-v2",
    "baseId": "sarees",
    "template": "sarees",
    "layout": "v2",
    "name": "Kanchi Weaves Studio",
    "label": "Silk & Handloom Sarees v2",
    "icon": "🥻",
    "note": "Kanchipuram silk, soft silk, handloom cotton and Kerala sarees straight from weavers. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "saree business",
    "demo": "sarees-v2",
    "url": "https://sarees-v2.ownezzy.com",
    "pitch": "Sell silk and handloom sarees online (Studio design)",
    "preview": "https://ownezzy.com/previews/sarees-v2-480.webp?v=8",
    "theme": {
      "main": "#7e22ce",
      "soft": "#f3e8ff",
      "warm": "#fdf2f8"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "sweets",
    "baseId": "sweets",
    "template": "sweets",
    "name": "MithaiMane",
    "label": "Homemade Sweets",
    "icon": "🪔",
    "note": "Laddus, Mysore pak, halwa, barfi and festival sweet boxes made in pure ghee.",
    "business": "homemade sweets business",
    "demo": "sweets",
    "url": "https://sweets.ownezzy.com",
    "pitch": "Sell homemade sweets and festival boxes online",
    "preview": "https://ownezzy.com/previews/sweets-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#ffedd5",
      "warm": "#fef9c3"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "sweets-v2",
    "baseId": "sweets",
    "template": "sweets",
    "layout": "v2",
    "name": "MithaiMane Studio",
    "label": "Homemade Sweets v2",
    "icon": "🪔",
    "note": "Laddus, Mysore pak, halwa, barfi and festival sweet boxes made in pure ghee. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "homemade sweets business",
    "demo": "sweets-v2",
    "url": "https://sweets-v2.ownezzy.com",
    "pitch": "Sell homemade sweets and festival boxes online (Studio design)",
    "preview": "https://ownezzy.com/previews/sweets-v2-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#ffedd5",
      "warm": "#fef9c3"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "herbal",
    "baseId": "herbal",
    "template": "herbal",
    "name": "Keshini Herbals",
    "label": "Herbal Hair Oils & Skin Care",
    "icon": "🌿",
    "note": "Herbal hair oils, hair masks, amla-shikakai powders, face packs and kumkumadi.",
    "business": "herbal hair & skin care business",
    "demo": "herbal",
    "url": "https://herbal.ownezzy.com",
    "pitch": "Sell herbal hair oils and skin care online",
    "preview": "https://ownezzy.com/previews/herbal-480.webp?v=8",
    "theme": {
      "main": "#15803d",
      "soft": "#dcfce7",
      "warm": "#ecfccb"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "herbal-v2",
    "baseId": "herbal",
    "template": "herbal",
    "layout": "v2",
    "name": "Keshini Herbals Studio",
    "label": "Herbal Hair Oils & Skin Care v2",
    "icon": "🌿",
    "note": "Herbal hair oils, hair masks, amla-shikakai powders, face packs and kumkumadi. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "herbal hair & skin care business",
    "demo": "herbal-v2",
    "url": "https://herbal-v2.ownezzy.com",
    "pitch": "Sell herbal hair oils and skin care online (Studio design)",
    "preview": "https://ownezzy.com/previews/herbal-v2-480.webp?v=8",
    "theme": {
      "main": "#15803d",
      "soft": "#dcfce7",
      "warm": "#ecfccb"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "healthmix",
    "baseId": "healthmix",
    "template": "healthmix",
    "name": "NalamMix",
    "label": "Health Mix & Baby Food",
    "icon": "🌾",
    "note": "Sathu maavu, ragi malt, millet mixes and homemade baby food with no sugar added.",
    "business": "health mix & millet business",
    "demo": "healthmix",
    "url": "https://healthmix.ownezzy.com",
    "pitch": "Sell health mix, millets and baby food online",
    "preview": "https://ownezzy.com/previews/healthmix-480.webp?v=8",
    "theme": {
      "main": "#a16207",
      "soft": "#fef9c3",
      "warm": "#ecfccb"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "healthmix-v2",
    "baseId": "healthmix",
    "template": "healthmix",
    "layout": "v2",
    "name": "NalamMix Studio",
    "label": "Health Mix & Baby Food v2",
    "icon": "🌾",
    "note": "Sathu maavu, ragi malt, millet mixes and homemade baby food with no sugar added. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "health mix & millet business",
    "demo": "healthmix-v2",
    "url": "https://healthmix-v2.ownezzy.com",
    "pitch": "Sell health mix, millets and baby food online (Studio design)",
    "preview": "https://ownezzy.com/previews/healthmix-v2-480.webp?v=8",
    "theme": {
      "main": "#a16207",
      "soft": "#fef9c3",
      "warm": "#ecfccb"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "dailywear",
    "baseId": "dailywear",
    "template": "dailywear",
    "name": "Tirupur Trends",
    "label": "Nighties, Kurtis & Leggings",
    "icon": "👚",
    "note": "Cotton kurtis, nightwear, lounge sets and leggings from Tirupur in sizes S to 5XL.",
    "business": "women daily wear business",
    "demo": "dailywear",
    "url": "https://dailywear.ownezzy.com",
    "pitch": "Sell kurtis, nighties and leggings online",
    "preview": "https://ownezzy.com/previews/dailywear-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#fce7f3",
      "warm": "#ede9fe"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "dailywear-v2",
    "baseId": "dailywear",
    "template": "dailywear",
    "layout": "v2",
    "name": "Tirupur Trends Studio",
    "label": "Nighties, Kurtis & Leggings v2",
    "icon": "👚",
    "note": "Cotton kurtis, nightwear, lounge sets and leggings from Tirupur in sizes S to 5XL. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "women daily wear business",
    "demo": "dailywear-v2",
    "url": "https://dailywear-v2.ownezzy.com",
    "pitch": "Sell kurtis, nighties and leggings online (Studio design)",
    "preview": "https://ownezzy.com/previews/dailywear-v2-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#fce7f3",
      "warm": "#ede9fe"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tiffin",
    "baseId": "tiffin",
    "template": "tiffin",
    "name": "Annapurna Kitchen",
    "label": "Home Food, Tiffin & Catering",
    "icon": "🍛",
    "note": "Tiffin, meals, biryani, weekly meal plans and party catering from a home kitchen.",
    "business": "home food & tiffin business",
    "demo": "tiffin",
    "url": "https://tiffin.ownezzy.com",
    "pitch": "Sell home-cooked food and tiffin online",
    "preview": "https://ownezzy.com/previews/tiffin-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#dcfce7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tiffin-v2",
    "baseId": "tiffin",
    "template": "tiffin",
    "layout": "v2",
    "name": "Annapurna Kitchen Studio",
    "label": "Home Food, Tiffin & Catering v2",
    "icon": "🍛",
    "note": "Tiffin, meals, biryani, weekly meal plans and party catering from a home kitchen. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "home food & tiffin business",
    "demo": "tiffin-v2",
    "url": "https://tiffin-v2.ownezzy.com",
    "pitch": "Sell home-cooked food and tiffin online (Studio design)",
    "preview": "https://ownezzy.com/previews/tiffin-v2-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#dcfce7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bangles",
    "baseId": "bangles",
    "template": "bangles",
    "name": "Valayal Studio",
    "label": "Bangles & Bridal Accessories",
    "icon": "💍",
    "note": "Silk thread and bridal bangles matched to your outfit, hair accessories and jasmine.",
    "business": "bangles & bridal accessories business",
    "demo": "bangles",
    "url": "https://bangles.ownezzy.com",
    "pitch": "Sell bangles and bridal accessories online",
    "preview": "https://ownezzy.com/previews/bangles-480.webp?v=8",
    "theme": {
      "main": "#e11d48",
      "soft": "#ffe4e6",
      "warm": "#f3e8ff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bangles-v2",
    "baseId": "bangles",
    "template": "bangles",
    "layout": "v2",
    "name": "Valayal Studio Studio",
    "label": "Bangles & Bridal Accessories v2",
    "icon": "💍",
    "note": "Silk thread and bridal bangles matched to your outfit, hair accessories and jasmine. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "bangles & bridal accessories business",
    "demo": "bangles-v2",
    "url": "https://bangles-v2.ownezzy.com",
    "pitch": "Sell bangles and bridal accessories online (Studio design)",
    "preview": "https://ownezzy.com/previews/bangles-v2-480.webp?v=8",
    "theme": {
      "main": "#e11d48",
      "soft": "#ffe4e6",
      "warm": "#f3e8ff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pooja",
    "baseId": "pooja",
    "template": "pooja",
    "name": "Deepam Pooja Store",
    "label": "Pooja Decor & Brass Items",
    "icon": "🪔",
    "note": "Brass diyas, pooja thalis, rangoli kits, incense, idols and mandir decor for every festival.",
    "business": "pooja items business",
    "demo": "pooja",
    "url": "https://pooja.ownezzy.com",
    "pitch": "Sell pooja items and brass decor online",
    "preview": "https://ownezzy.com/previews/pooja-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#fef3c7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pooja-v2",
    "baseId": "pooja",
    "template": "pooja",
    "layout": "v2",
    "name": "Deepam Pooja Store Studio",
    "label": "Pooja Decor & Brass Items v2",
    "icon": "🪔",
    "note": "Brass diyas, pooja thalis, rangoli kits, incense, idols and mandir decor for every festival. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "pooja items business",
    "demo": "pooja-v2",
    "url": "https://pooja-v2.ownezzy.com",
    "pitch": "Sell pooja items and brass decor online (Studio design)",
    "preview": "https://ownezzy.com/previews/pooja-v2-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#fef3c7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "electronics",
    "baseId": "electronics",
    "template": "electronics",
    "name": "VoltKart",
    "label": "Electronics & Gadgets",
    "icon": "🎧",
    "note": "Earbuds, headphones, smart watches, chargers, power banks, speakers and smart bulbs with warranty.",
    "business": "electronics & gadgets business",
    "demo": "electronics",
    "url": "https://electronics.ownezzy.com",
    "pitch": "Sell earbuds, smart watches and gadgets online",
    "preview": "https://ownezzy.com/previews/electronics-480.webp?v=8",
    "theme": {
      "main": "#2563eb",
      "soft": "#dbeafe",
      "warm": "#ecfeff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "electronics-v2",
    "baseId": "electronics",
    "template": "electronics",
    "layout": "v2",
    "name": "VoltKart Studio",
    "label": "Electronics & Gadgets v2",
    "icon": "🎧",
    "note": "Earbuds, headphones, smart watches, chargers, power banks, speakers and smart bulbs with warranty. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "electronics & gadgets business",
    "demo": "electronics-v2",
    "url": "https://electronics-v2.ownezzy.com",
    "pitch": "Sell earbuds, smart watches and gadgets online (Studio design)",
    "preview": "https://ownezzy.com/previews/electronics-v2-480.webp?v=8",
    "theme": {
      "main": "#2563eb",
      "soft": "#dbeafe",
      "warm": "#ecfeff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "comics",
    "baseId": "comics",
    "template": "comics",
    "name": "Panel House Comics",
    "label": "Comic Books & Manga",
    "icon": "💥",
    "note": "Marvel, DC and Raj Comics, manga, graphic novels and collectible figures, new and pre-loved.",
    "business": "comic book business",
    "demo": "comics",
    "url": "https://comics.ownezzy.com",
    "pitch": "Sell comics, manga and collectibles online",
    "preview": "https://ownezzy.com/previews/comics-480.webp?v=8",
    "theme": {
      "main": "#dc2626",
      "soft": "#fee2e2",
      "warm": "#fef9c3"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "comics-v2",
    "baseId": "comics",
    "template": "comics",
    "layout": "v2",
    "name": "Panel House Comics Studio",
    "label": "Comic Books & Manga v2",
    "icon": "💥",
    "note": "Marvel, DC and Raj Comics, manga, graphic novels and collectible figures, new and pre-loved. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "comic book business",
    "demo": "comics-v2",
    "url": "https://comics-v2.ownezzy.com",
    "pitch": "Sell comics, manga and collectibles online (Studio design)",
    "preview": "https://ownezzy.com/previews/comics-v2-480.webp?v=8",
    "theme": {
      "main": "#dc2626",
      "soft": "#fee2e2",
      "warm": "#fef9c3"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "coconutoil",
    "baseId": "coconutoil",
    "template": "coconutoil",
    "name": "Thengai Naturals",
    "label": "Homemade Coconut Oil",
    "icon": "🥥",
    "note": "Wood-pressed and virgin coconut oil, herbal hair oils, coconut soaps and coconut foods.",
    "business": "coconut oil business",
    "demo": "coconutoil",
    "url": "https://coconutoil.ownezzy.com",
    "pitch": "Sell homemade coconut oil online",
    "preview": "https://ownezzy.com/previews/coconutoil-480.webp?v=8",
    "theme": {
      "main": "#65a30d",
      "soft": "#ecfccb",
      "warm": "#fef3c7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "coconutoil-v2",
    "baseId": "coconutoil",
    "template": "coconutoil",
    "layout": "v2",
    "name": "Thengai Naturals Studio",
    "label": "Homemade Coconut Oil v2",
    "icon": "🥥",
    "note": "Wood-pressed and virgin coconut oil, herbal hair oils, coconut soaps and coconut foods. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "coconut oil business",
    "demo": "coconutoil-v2",
    "url": "https://coconutoil-v2.ownezzy.com",
    "pitch": "Sell homemade coconut oil online (Studio design)",
    "preview": "https://ownezzy.com/previews/coconutoil-v2-480.webp?v=8",
    "theme": {
      "main": "#65a30d",
      "soft": "#ecfccb",
      "warm": "#fef3c7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "cleaning",
    "baseId": "cleaning",
    "template": "cleaning",
    "name": "SparkleHome",
    "label": "Bathroom & Toilet Cleaners",
    "icon": "🧽",
    "note": "Toilet, bathroom, tile and floor cleaners, phenyl, brushes, mops and fresheners in retail and bulk.",
    "business": "cleaning products business",
    "demo": "cleaning",
    "url": "https://cleaning.ownezzy.com",
    "pitch": "Sell cleaning products online",
    "preview": "https://ownezzy.com/previews/cleaning-480.webp?v=8",
    "theme": {
      "main": "#0891b2",
      "soft": "#cffafe",
      "warm": "#dcfce7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "cleaning-v2",
    "baseId": "cleaning",
    "template": "cleaning",
    "layout": "v2",
    "name": "SparkleHome Studio",
    "label": "Bathroom & Toilet Cleaners v2",
    "icon": "🧽",
    "note": "Toilet, bathroom, tile and floor cleaners, phenyl, brushes, mops and fresheners in retail and bulk. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "cleaning products business",
    "demo": "cleaning-v2",
    "url": "https://cleaning-v2.ownezzy.com",
    "pitch": "Sell cleaning products online (Studio design)",
    "preview": "https://ownezzy.com/previews/cleaning-v2-480.webp?v=8",
    "theme": {
      "main": "#0891b2",
      "soft": "#cffafe",
      "warm": "#dcfce7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "artjewellery",
    "baseId": "artjewellery",
    "template": "artjewellery",
    "name": "Kaari Handmade Jewellery",
    "label": "Artificial & Handmade Jewellery",
    "icon": "💖",
    "note": "Handmade resin, rattan, beaded and wire earrings, necklaces, bracelets, rings and anklets.",
    "business": "handmade jewellery business",
    "demo": "artjewellery",
    "url": "https://artjewellery.ownezzy.com",
    "pitch": "Sell handmade and artificial jewellery online",
    "preview": "https://ownezzy.com/previews/artjewellery-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fef3c7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "artjewellery-v2",
    "baseId": "artjewellery",
    "template": "artjewellery",
    "layout": "v2",
    "name": "Kaari Handmade Jewellery Studio",
    "label": "Artificial & Handmade Jewellery v2",
    "icon": "💖",
    "note": "Handmade resin, rattan, beaded and wire earrings, necklaces, bracelets, rings and anklets. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "handmade jewellery business",
    "demo": "artjewellery-v2",
    "url": "https://artjewellery-v2.ownezzy.com",
    "pitch": "Sell handmade and artificial jewellery online (Studio design)",
    "preview": "https://ownezzy.com/previews/artjewellery-v2-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fef3c7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "wallclocks",
    "baseId": "wallclocks",
    "template": "wallclocks",
    "name": "Tick Art Clocks",
    "label": "Acrylic Wall Clocks",
    "icon": "🕰️",
    "note": "Acrylic, resin, Roman, vintage and pendulum wall clocks and custom photo clocks.",
    "business": "wall clock business",
    "demo": "wallclocks",
    "url": "https://wallclocks.ownezzy.com",
    "pitch": "Sell acrylic and designer wall clocks online",
    "preview": "https://ownezzy.com/previews/wallclocks-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#fce7f3"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "wallclocks-v2",
    "baseId": "wallclocks",
    "template": "wallclocks",
    "layout": "v2",
    "name": "Tick Art Clocks Studio",
    "label": "Acrylic Wall Clocks v2",
    "icon": "🕰️",
    "note": "Acrylic, resin, Roman, vintage and pendulum wall clocks and custom photo clocks. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "wall clock business",
    "demo": "wallclocks-v2",
    "url": "https://wallclocks-v2.ownezzy.com",
    "pitch": "Sell acrylic and designer wall clocks online (Studio design)",
    "preview": "https://ownezzy.com/previews/wallclocks-v2-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#fce7f3"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "mirrors",
    "baseId": "mirrors",
    "template": "mirrors",
    "name": "Reflekt Mirrors",
    "label": "Acrylic & Wall Mirrors",
    "icon": "🪞",
    "note": "Round, sunburst, bathroom, vanity and full-length mirrors and acrylic mirror decor in custom sizes.",
    "business": "mirror business",
    "demo": "mirrors",
    "url": "https://mirrors.ownezzy.com",
    "pitch": "Sell wall mirrors and acrylic mirror decor online",
    "preview": "https://ownezzy.com/previews/mirrors-480.webp?v=8",
    "theme": {
      "main": "#0f766e",
      "soft": "#ccfbf1",
      "warm": "#fef3c7"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "mirrors-v2",
    "baseId": "mirrors",
    "template": "mirrors",
    "layout": "v2",
    "name": "Reflekt Mirrors Studio",
    "label": "Acrylic & Wall Mirrors v2",
    "icon": "🪞",
    "note": "Round, sunburst, bathroom, vanity and full-length mirrors and acrylic mirror decor in custom sizes. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "mirror business",
    "demo": "mirrors-v2",
    "url": "https://mirrors-v2.ownezzy.com",
    "pitch": "Sell wall mirrors and acrylic mirror decor online (Studio design)",
    "preview": "https://ownezzy.com/previews/mirrors-v2-480.webp?v=8",
    "theme": {
      "main": "#0f766e",
      "soft": "#ccfbf1",
      "warm": "#fef3c7"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "candles",
    "baseId": "candles",
    "template": "candles",
    "name": "Wick & Glow",
    "label": "Scented Candles",
    "icon": "🕯️",
    "note": "Hand-poured soy wax jar candles, pillars, shaped candles, tealights and candle gift sets.",
    "business": "scented candle business",
    "demo": "candles",
    "url": "https://candles.ownezzy.com",
    "pitch": "Sell scented candles online",
    "preview": "https://ownezzy.com/previews/candles-480.webp?v=8",
    "theme": {
      "main": "#b45309",
      "soft": "#ffedd5",
      "warm": "#fce7f3"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "candles-v2",
    "baseId": "candles",
    "template": "candles",
    "layout": "v2",
    "name": "Wick & Glow Studio",
    "label": "Scented Candles v2",
    "icon": "🕯️",
    "note": "Hand-poured soy wax jar candles, pillars, shaped candles, tealights and candle gift sets. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "scented candle business",
    "demo": "candles-v2",
    "url": "https://candles-v2.ownezzy.com",
    "pitch": "Sell scented candles online (Studio design)",
    "preview": "https://ownezzy.com/previews/candles-v2-480.webp?v=8",
    "theme": {
      "main": "#b45309",
      "soft": "#ffedd5",
      "warm": "#fce7f3"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "plants",
    "baseId": "plants",
    "template": "plants",
    "name": "GreenNest",
    "label": "Plants & Gardening",
    "icon": "🌱",
    "note": "Plants, pots, seeds and gardening products in a fresh layout.",
    "business": "plant business",
    "demo": "plants",
    "url": "https://plants.ownezzy.com",
    "pitch": "Sell plants, pots and seeds online",
    "preview": "https://ownezzy.com/previews/plants-480.webp?v=8",
    "theme": {
      "main": "#205f3d",
      "soft": "#e7f7d9",
      "warm": "#ffe8d2"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "plants-v2",
    "baseId": "plants",
    "template": "plants",
    "layout": "v2",
    "name": "GreenNest Studio",
    "label": "Plants & Gardening v2",
    "icon": "🌱",
    "note": "Plants, pots, seeds and gardening products in a fresh layout. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "plant business",
    "demo": "plants-v2",
    "url": "https://plants-v2.ownezzy.com",
    "pitch": "Sell plants, pots and seeds online (Studio design)",
    "preview": "https://ownezzy.com/previews/plants-v2-480.webp?v=8",
    "theme": {
      "main": "#205f3d",
      "soft": "#e7f7d9",
      "warm": "#ffe8d2"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "gifts",
    "baseId": "gifts",
    "template": "gifts",
    "name": "Giftly",
    "label": "Gift Store",
    "icon": "🎁",
    "note": "Hampers, flowers, chocolates and gifts for every occasion.",
    "business": "gift business",
    "demo": "gifts",
    "url": "https://gifts.ownezzy.com",
    "pitch": "Sell gifts, flowers and hampers online",
    "preview": "https://ownezzy.com/previews/gifts-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#fde8f1",
      "warm": "#ffe6dc"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "gifts-v2",
    "baseId": "gifts",
    "template": "gifts",
    "layout": "v2",
    "name": "Giftly Studio",
    "label": "Gift Store v2",
    "icon": "🎁",
    "note": "Hampers, flowers, chocolates and gifts for every occasion. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "gift business",
    "demo": "gifts-v2",
    "url": "https://gifts-v2.ownezzy.com",
    "pitch": "Sell gifts, flowers and hampers online (Studio design)",
    "preview": "https://ownezzy.com/previews/gifts-v2-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#fde8f1",
      "warm": "#ffe6dc"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pets",
    "baseId": "pets",
    "template": "pets",
    "name": "PawPantry",
    "label": "Pet Store",
    "icon": "🐾",
    "note": "Pet food, toys, grooming and everyday essentials.",
    "business": "pet business",
    "demo": "pet",
    "url": "https://pet.ownezzy.com",
    "pitch": "Sell pet food, toys and accessories online",
    "preview": "https://ownezzy.com/previews/pets-480.webp?v=8",
    "theme": {
      "main": "#807a12",
      "soft": "#fffbbd",
      "warm": "#fff7db"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pets-v2",
    "baseId": "pets",
    "template": "pets",
    "layout": "v2",
    "name": "PawPantry Studio",
    "label": "Pet Store v2",
    "icon": "🐾",
    "note": "Pet food, toys, grooming and everyday essentials. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "pet business",
    "demo": "pet-v2",
    "url": "https://pet-v2.ownezzy.com",
    "pitch": "Sell pet food, toys and accessories online (Studio design)",
    "preview": "https://ownezzy.com/previews/pets-v2-480.webp?v=8",
    "theme": {
      "main": "#807a12",
      "soft": "#fffbbd",
      "warm": "#fff7db"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "aquarium",
    "baseId": "aquarium",
    "template": "aquarium",
    "name": "AquaLeaf",
    "label": "Aquarium Store",
    "icon": "🐠",
    "note": "Fish, aquarium plants, tanks and fish food.",
    "business": "aquarium business",
    "demo": "aqualeaf",
    "url": "https://aqualeaf.ownezzy.com",
    "pitch": "Sell fish, aquarium plants and tanks online",
    "preview": "https://ownezzy.com/previews/aquarium-480.webp?v=8",
    "theme": {
      "main": "#059669",
      "soft": "#e3f6ef",
      "warm": "#dff4ea"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "aquarium-v2",
    "baseId": "aquarium",
    "template": "aquarium",
    "layout": "v2",
    "name": "AquaLeaf Studio",
    "label": "Aquarium Store v2",
    "icon": "🐠",
    "note": "Fish, aquarium plants, tanks and fish food. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "aquarium business",
    "demo": "aqualeaf-v2",
    "url": "https://aqualeaf-v2.ownezzy.com",
    "pitch": "Sell fish, aquarium plants and tanks online (Studio design)",
    "preview": "https://ownezzy.com/previews/aquarium-v2-480.webp?v=8",
    "theme": {
      "main": "#059669",
      "soft": "#e3f6ef",
      "warm": "#dff4ea"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "wellness",
    "baseId": "wellness",
    "template": "selfcare",
    "name": "Lather & Bloom",
    "label": "Soaps & Perfumes",
    "icon": "🧼",
    "note": "Handmade soaps, perfumes, handwash and gift sets.",
    "business": "soap & perfume business",
    "demo": "soaps",
    "url": "https://soaps.ownezzy.com",
    "pitch": "Sell handmade soaps, perfumes and handwash online",
    "preview": "https://ownezzy.com/previews/wellness-480.webp?v=8",
    "theme": {
      "main": "#7e5aa2",
      "soft": "#f2ebfa",
      "warm": "#fde8f1"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "wellness-v2",
    "baseId": "wellness",
    "template": "selfcare",
    "layout": "v2",
    "name": "Lather & Bloom Studio",
    "label": "Soaps & Perfumes v2",
    "icon": "🧼",
    "note": "Handmade soaps, perfumes, handwash and gift sets. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "soap & perfume business",
    "demo": "soaps-v2",
    "url": "https://soaps-v2.ownezzy.com",
    "pitch": "Sell handmade soaps, perfumes and handwash online (Studio design)",
    "preview": "https://ownezzy.com/previews/wellness-v2-480.webp?v=8",
    "theme": {
      "main": "#7e5aa2",
      "soft": "#f2ebfa",
      "warm": "#fde8f1"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "footwear",
    "baseId": "footwear",
    "template": "footwear",
    "name": "SoleChic",
    "label": "Footwear & Juttis",
    "icon": "👡",
    "note": "Bridal juttis, flats, party heels, sneakers and men's leather shoes with size options.",
    "business": "footwear & jutti business",
    "demo": "footwear",
    "url": "https://footwear.ownezzy.com",
    "pitch": "Sell juttis, heels, sneakers & shoes online",
    "preview": "https://ownezzy.com/previews/footwear-480.webp?v=8",
    "theme": {
      "main": "#a21caf",
      "soft": "#fae8ff",
      "warm": "#fdf4ff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "footwear-v2",
    "baseId": "footwear",
    "template": "footwear",
    "layout": "v2",
    "name": "SoleChic Studio",
    "label": "Footwear & Juttis v2",
    "icon": "👡",
    "note": "Bridal juttis, flats, party heels, sneakers and men's leather shoes with size options. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "footwear & jutti business",
    "demo": "footwear-v2",
    "url": "https://footwear-v2.ownezzy.com",
    "pitch": "Sell juttis, heels, sneakers & shoes online (Studio design)",
    "preview": "https://ownezzy.com/previews/footwear-v2-480.webp?v=8",
    "theme": {
      "main": "#a21caf",
      "soft": "#fae8ff",
      "warm": "#fdf4ff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "uruli",
    "baseId": "uruli",
    "template": "uruli",
    "name": "Paramparya",
    "label": "Brassware & Bronze Urulis",
    "icon": "🪔",
    "note": "Brass urulis, vilakku lamps, pooja thalis, deity idols, temple bells and diyas.",
    "business": "traditional brassware & pooja decor business",
    "demo": "uruli",
    "url": "https://uruli.ownezzy.com",
    "pitch": "Sell handcrafted brassware, bronze urulis & pooja decor online",
    "preview": "https://ownezzy.com/previews/uruli-480.webp?v=8",
    "theme": {
      "main": "#b45309",
      "soft": "#fef3c7",
      "warm": "#fffbeb"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "uruli-v2",
    "baseId": "uruli",
    "template": "uruli",
    "layout": "v2",
    "name": "Paramparya Studio",
    "label": "Brassware & Bronze Urulis v2",
    "icon": "🪔",
    "note": "Brass urulis, vilakku lamps, pooja thalis, deity idols, temple bells and diyas. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "traditional brassware & pooja decor business",
    "demo": "uruli-v2",
    "url": "https://uruli-v2.ownezzy.com",
    "pitch": "Sell handcrafted brassware, bronze urulis & pooja decor online (Studio design)",
    "preview": "https://ownezzy.com/previews/uruli-v2-480.webp?v=8",
    "theme": {
      "main": "#b45309",
      "soft": "#fef3c7",
      "warm": "#fffbeb"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "grocery",
    "baseId": "grocery",
    "template": "grocery",
    "name": "DailyBasket",
    "label": "Grocery Store",
    "icon": "🛒",
    "note": "Daily essentials, snacks, drinks and weekly offers.",
    "business": "grocery business",
    "demo": "grocery",
    "url": "https://grocery.ownezzy.com",
    "pitch": "Sell groceries and daily essentials online",
    "preview": "https://ownezzy.com/previews/grocery-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#fff0e3",
      "warm": "#fff6d6"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "grocery-v2",
    "baseId": "grocery",
    "template": "grocery",
    "layout": "v2",
    "name": "DailyBasket Studio",
    "label": "Grocery Store v2",
    "icon": "🛒",
    "note": "Daily essentials, snacks, drinks and weekly offers. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "grocery business",
    "demo": "grocery-v2",
    "url": "https://grocery-v2.ownezzy.com",
    "pitch": "Sell groceries and daily essentials online (Studio design)",
    "preview": "https://ownezzy.com/previews/grocery-v2-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#fff0e3",
      "warm": "#fff6d6"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "fresh",
    "baseId": "fresh",
    "template": "fresh",
    "name": "FarmFresh",
    "label": "Fruits & Vegetables",
    "icon": "🥬",
    "note": "Farm-fresh fruits, vegetables, greens and dry fruits.",
    "business": "fruit & vegetable business",
    "demo": "fresh",
    "url": "https://fresh.ownezzy.com",
    "pitch": "Sell fresh fruits and vegetables online",
    "preview": "https://ownezzy.com/previews/fresh-480.webp?v=8",
    "theme": {
      "main": "#4d7c0f",
      "soft": "#eef7dc",
      "warm": "#fff2cc"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "fresh-v2",
    "baseId": "fresh",
    "template": "fresh",
    "layout": "v2",
    "name": "FarmFresh Studio",
    "label": "Fruits & Vegetables v2",
    "icon": "🥬",
    "note": "Farm-fresh fruits, vegetables, greens and dry fruits. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "fruit & vegetable business",
    "demo": "fresh-v2",
    "url": "https://fresh-v2.ownezzy.com",
    "pitch": "Sell fresh fruits and vegetables online (Studio design)",
    "preview": "https://ownezzy.com/previews/fresh-v2-480.webp?v=8",
    "theme": {
      "main": "#4d7c0f",
      "soft": "#eef7dc",
      "warm": "#fff2cc"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tech",
    "baseId": "tech",
    "template": "tech",
    "name": "CaseVault",
    "label": "Phone Cases & Tech",
    "icon": "📱",
    "note": "Printed, silicone, leather and rugged phone cases, custom photo cases and accessories.",
    "business": "phone cases & tech accessories business",
    "demo": "cases",
    "url": "https://cases.ownezzy.com",
    "pitch": "Sell phone cases, skins & accessories online",
    "preview": "https://ownezzy.com/previews/tech-480.webp?v=8",
    "theme": {
      "main": "#2563eb",
      "soft": "#eff6ff",
      "warm": "#dbeafe"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tech-v2",
    "baseId": "tech",
    "template": "tech",
    "layout": "v2",
    "name": "CaseVault Studio",
    "label": "Phone Cases & Tech v2",
    "icon": "📱",
    "note": "Printed, silicone, leather and rugged phone cases, custom photo cases and accessories. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "phone cases & tech accessories business",
    "demo": "cases-v2",
    "url": "https://cases-v2.ownezzy.com",
    "pitch": "Sell phone cases, skins & accessories online (Studio design)",
    "preview": "https://ownezzy.com/previews/tech-v2-480.webp?v=8",
    "theme": {
      "main": "#2563eb",
      "soft": "#eff6ff",
      "warm": "#dbeafe"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bags",
    "baseId": "bags",
    "template": "bags",
    "name": "ToteVibe",
    "label": "Bags & Totes",
    "icon": "👜",
    "note": "Totes, handbags, slings, laptop backpacks and party clutches.",
    "business": "bags & accessories business",
    "demo": "bags",
    "url": "https://bags.ownezzy.com",
    "pitch": "Sell totes, handbags, backpacks & clutches online",
    "preview": "https://ownezzy.com/previews/bags-480.webp?v=8",
    "theme": {
      "main": "#0d9488",
      "soft": "#ccfbf1",
      "warm": "#f0fdfa"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bags-v2",
    "baseId": "bags",
    "template": "bags",
    "layout": "v2",
    "name": "ToteVibe Studio",
    "label": "Bags & Totes v2",
    "icon": "👜",
    "note": "Totes, handbags, slings, laptop backpacks and party clutches. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "bags & accessories business",
    "demo": "bags-v2",
    "url": "https://bags-v2.ownezzy.com",
    "pitch": "Sell totes, handbags, backpacks & clutches online (Studio design)",
    "preview": "https://ownezzy.com/previews/bags-v2-480.webp?v=8",
    "theme": {
      "main": "#0d9488",
      "soft": "#ccfbf1",
      "warm": "#f0fdfa"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "crafts",
    "baseId": "crafts",
    "template": "crafts",
    "name": "CraftedCanvas",
    "label": "Handmade Crafts & Decor",
    "icon": "🧵",
    "note": "Macrame wall hangings, dried flower bouquets, hand-painted pottery and wooden handicrafts.",
    "business": "custom crafts & resin business",
    "demo": "crafts",
    "url": "https://crafts.ownezzy.com",
    "pitch": "Sell macrame, dried flowers & handmade crafts online",
    "preview": "https://ownezzy.com/previews/crafts-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#ffedd5",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "crafts-v2",
    "baseId": "crafts",
    "template": "crafts",
    "layout": "v2",
    "name": "CraftedCanvas Studio",
    "label": "Handmade Crafts & Decor v2",
    "icon": "🧵",
    "note": "Macrame wall hangings, dried flower bouquets, hand-painted pottery and wooden handicrafts. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "custom crafts & resin business",
    "demo": "crafts-v2",
    "url": "https://crafts-v2.ownezzy.com",
    "pitch": "Sell macrame, dried flowers & handmade crafts online (Studio design)",
    "preview": "https://ownezzy.com/previews/crafts-v2-480.webp?v=8",
    "theme": {
      "main": "#ea580c",
      "soft": "#ffedd5",
      "warm": "#fff7ed"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "decor",
    "baseId": "decor",
    "template": "decor",
    "name": "LuminaNest",
    "label": "Home Decor & Candles",
    "icon": "🕯️",
    "note": "Scented soy candles, ceramic vases, mugs, rattan decor and reed diffusers.",
    "business": "home decor & candle business",
    "demo": "decor",
    "url": "https://decor.ownezzy.com",
    "pitch": "Sell scented soy candles, ceramics & home decor online",
    "preview": "https://ownezzy.com/previews/decor-480.webp?v=8",
    "theme": {
      "main": "#d97706",
      "soft": "#fef3c7",
      "warm": "#fffbeb"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "decor-v2",
    "baseId": "decor",
    "template": "decor",
    "layout": "v2",
    "name": "LuminaNest Studio",
    "label": "Home Decor & Candles v2",
    "icon": "🕯️",
    "note": "Scented soy candles, ceramic vases, mugs, rattan decor and reed diffusers. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "home decor & candle business",
    "demo": "decor-v2",
    "url": "https://decor-v2.ownezzy.com",
    "pitch": "Sell scented soy candles, ceramics & home decor online (Studio design)",
    "preview": "https://ownezzy.com/previews/decor-v2-480.webp?v=8",
    "theme": {
      "main": "#d97706",
      "soft": "#fef3c7",
      "warm": "#fffbeb"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "blouses",
    "baseId": "blouses",
    "template": "blouses",
    "name": "AariBoutique",
    "label": "Sarees & Designer Blouses",
    "icon": "🥻",
    "note": "Designer blouses, silk sarees and bridal lehengas stitched to your size.",
    "business": "designer blouse & Aari boutique",
    "demo": "blouses",
    "url": "https://blouses.ownezzy.com",
    "pitch": "Sell designer blouses, silk sarees & lehengas online",
    "preview": "https://ownezzy.com/previews/blouses-480.webp?v=8",
    "theme": {
      "main": "#9d174d",
      "soft": "#fce7f3",
      "warm": "#fff1f2"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "blouses-v2",
    "baseId": "blouses",
    "template": "blouses",
    "layout": "v2",
    "name": "AariBoutique Studio",
    "label": "Sarees & Designer Blouses v2",
    "icon": "🥻",
    "note": "Designer blouses, silk sarees and bridal lehengas stitched to your size. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "designer blouse & Aari boutique",
    "demo": "blouses-v2",
    "url": "https://blouses-v2.ownezzy.com",
    "pitch": "Sell designer blouses, silk sarees & lehengas online (Studio design)",
    "preview": "https://ownezzy.com/previews/blouses-v2-480.webp?v=8",
    "theme": {
      "main": "#9d174d",
      "soft": "#fce7f3",
      "warm": "#fff1f2"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "favors",
    "baseId": "favors",
    "template": "favors",
    "name": "UtsavFavors",
    "label": "Wedding & Return Favors",
    "icon": "🎁",
    "note": "Thamboolam potlis, wedding favor boxes, sweet jars and festive gift hampers in bulk.",
    "business": "wedding return gift & favor business",
    "demo": "favors",
    "url": "https://favors.ownezzy.com",
    "pitch": "Sell wedding return gifts, thamboolam bags & favors online",
    "preview": "https://ownezzy.com/previews/favors-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "favors-v2",
    "baseId": "favors",
    "template": "favors",
    "layout": "v2",
    "name": "UtsavFavors Studio",
    "label": "Wedding & Return Favors v2",
    "icon": "🎁",
    "note": "Thamboolam potlis, wedding favor boxes, sweet jars and festive gift hampers in bulk. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "wedding return gift & favor business",
    "demo": "favors-v2",
    "url": "https://favors-v2.ownezzy.com",
    "pitch": "Sell wedding return gifts, thamboolam bags & favors online (Studio design)",
    "preview": "https://ownezzy.com/previews/favors-v2-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#ffedd5",
      "warm": "#fff7ed"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "resin",
    "baseId": "resin",
    "template": "resin",
    "name": "ResinBlossoms",
    "label": "Resin Art & Flower Keepsakes",
    "icon": "🌸",
    "note": "Resin coasters, real-flower jewellery, pressed flower frames and geode wall art.",
    "business": "floral resin preservation business",
    "demo": "resin",
    "url": "https://resin.ownezzy.com",
    "pitch": "Sell resin art, flower jewellery & keepsakes online",
    "preview": "https://ownezzy.com/previews/resin-480.webp?v=8",
    "theme": {
      "main": "#0f766e",
      "soft": "#ccfbf1",
      "warm": "#f0fdfa"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "resin-v2",
    "baseId": "resin",
    "template": "resin",
    "layout": "v2",
    "name": "ResinBlossoms Studio",
    "label": "Resin Art & Flower Keepsakes v2",
    "icon": "🌸",
    "note": "Resin coasters, real-flower jewellery, pressed flower frames and geode wall art. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "floral resin preservation business",
    "demo": "resin-v2",
    "url": "https://resin-v2.ownezzy.com",
    "pitch": "Sell resin art, flower jewellery & keepsakes online (Studio design)",
    "preview": "https://ownezzy.com/previews/resin-v2-480.webp?v=8",
    "theme": {
      "main": "#0f766e",
      "soft": "#ccfbf1",
      "warm": "#f0fdfa"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "crochet",
    "baseId": "crochet",
    "template": "crochet",
    "name": "YarnBlooms",
    "label": "Crochet Bouquets & Plushies",
    "icon": "🧶",
    "note": "Everlasting crochet bouquets, keychains, amigurumi plushies and crochet bags.",
    "business": "crochet bouquet & amigurumi business",
    "demo": "crochet",
    "url": "https://crochet.ownezzy.com",
    "pitch": "Sell handmade crochet flower bouquets & amigurumi gifts online",
    "preview": "https://ownezzy.com/previews/crochet-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#f5f3ff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "crochet-v2",
    "baseId": "crochet",
    "template": "crochet",
    "layout": "v2",
    "name": "YarnBlooms Studio",
    "label": "Crochet Bouquets & Plushies v2",
    "icon": "🧶",
    "note": "Everlasting crochet bouquets, keychains, amigurumi plushies and crochet bags. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "crochet bouquet & amigurumi business",
    "demo": "crochet-v2",
    "url": "https://crochet-v2.ownezzy.com",
    "pitch": "Sell handmade crochet flower bouquets & amigurumi gifts online (Studio design)",
    "preview": "https://ownezzy.com/previews/crochet-v2-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#f5f3ff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pattu",
    "baseId": "pattu",
    "template": "pattu",
    "name": "KuttyPattu",
    "label": "Kids Ethnic & Pattu Pavadai",
    "icon": "🧒",
    "note": "Pattu pavadai, lehenga cholis, boys kurta sets and matching sibling outfits.",
    "business": "kids traditional & pattu pavadai business",
    "demo": "pattu",
    "url": "https://pattu.ownezzy.com",
    "pitch": "Sell kids pattu pavadai, silk dhotis & festive wear online",
    "preview": "https://ownezzy.com/previews/pattu-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fff1f2"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pattu-v2",
    "baseId": "pattu",
    "template": "pattu",
    "layout": "v2",
    "name": "KuttyPattu Studio",
    "label": "Kids Ethnic & Pattu Pavadai v2",
    "icon": "🧒",
    "note": "Pattu pavadai, lehenga cholis, boys kurta sets and matching sibling outfits. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "kids traditional & pattu pavadai business",
    "demo": "pattu-v2",
    "url": "https://pattu-v2.ownezzy.com",
    "pitch": "Sell kids pattu pavadai, silk dhotis & festive wear online (Studio design)",
    "preview": "https://ownezzy.com/previews/pattu-v2-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#fce7f3",
      "warm": "#fff1f2"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "linens",
    "baseId": "linens",
    "template": "linens",
    "name": "DesiLoom",
    "label": "Bedsheets & Home Linen",
    "icon": "🛏️",
    "note": "Printed cotton bedsheets, patchwork quilts, cushion covers, durries and block print fabrics.",
    "business": "handblock bedsheet & home linen business",
    "demo": "linens",
    "url": "https://linens.ownezzy.com",
    "pitch": "Sell handblock cotton bedsheets, dohars & linens online",
    "preview": "https://ownezzy.com/previews/linens-480.webp?v=8",
    "theme": {
      "main": "#0891b2",
      "soft": "#e0f2fe",
      "warm": "#f0f9ff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "linens-v2",
    "baseId": "linens",
    "template": "linens",
    "layout": "v2",
    "name": "DesiLoom Studio",
    "label": "Bedsheets & Home Linen v2",
    "icon": "🛏️",
    "note": "Printed cotton bedsheets, patchwork quilts, cushion covers, durries and block print fabrics. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "handblock bedsheet & home linen business",
    "demo": "linens-v2",
    "url": "https://linens-v2.ownezzy.com",
    "pitch": "Sell handblock cotton bedsheets, dohars & linens online (Studio design)",
    "preview": "https://ownezzy.com/previews/linens-v2-480.webp?v=8",
    "theme": {
      "main": "#0891b2",
      "soft": "#e0f2fe",
      "warm": "#f0f9ff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tshirts",
    "baseId": "tshirts",
    "template": "tshirts",
    "name": "PrintPop Tees",
    "label": "Custom Printed T-Shirts",
    "icon": "👕",
    "note": "Custom printed tees for men, women, boys & girls with names, photos and a live design preview.",
    "business": "custom T-shirt printing business",
    "demo": "tees",
    "url": "https://tees.ownezzy.com",
    "pitch": "Sell custom printed T-shirts with live photo & name preview",
    "preview": "https://ownezzy.com/previews/tshirts-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#fdf4ff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tshirts-v2",
    "baseId": "tshirts",
    "template": "tshirts",
    "layout": "v2",
    "name": "PrintPop Tees Studio",
    "label": "Custom Printed T-Shirts v2",
    "icon": "👕",
    "note": "Custom printed tees for men, women, boys & girls with names, photos and a live design preview. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "custom T-shirt printing business",
    "demo": "tees-v2",
    "url": "https://tees-v2.ownezzy.com",
    "pitch": "Sell custom printed T-shirts with live photo & name preview (Studio design)",
    "preview": "https://ownezzy.com/previews/tshirts-v2-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#ede9fe",
      "warm": "#fdf4ff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "acrylic",
    "baseId": "acrylic",
    "template": "acrylic",
    "name": "AcrylicAura",
    "label": "Acrylic Photos & Wall Art",
    "icon": "🖼️",
    "note": "Acrylic photo frames, wall clocks, collages and wall art with a live photo preview.",
    "business": "acrylic photo frame & wall art business",
    "demo": "acrylic",
    "url": "https://acrylic.ownezzy.com",
    "pitch": "Sell acrylic photo frames, clocks & wall art with live preview",
    "preview": "https://ownezzy.com/previews/acrylic-480.webp?v=8",
    "theme": {
      "main": "#0e7490",
      "soft": "#cffafe",
      "warm": "#ecfeff"
    },
    "isV2": false,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "acrylic-v2",
    "baseId": "acrylic",
    "template": "acrylic",
    "layout": "v2",
    "name": "AcrylicAura Studio",
    "label": "Acrylic Photos & Wall Art v2",
    "icon": "🖼️",
    "note": "Acrylic photo frames, wall clocks, collages and wall art with a live photo preview. Studio design: split banner, photo category tiles and boxed product cards.",
    "business": "acrylic photo frame & wall art business",
    "demo": "acrylic-v2",
    "url": "https://acrylic-v2.ownezzy.com",
    "pitch": "Sell acrylic photo frames, clocks & wall art with live preview (Studio design)",
    "preview": "https://ownezzy.com/previews/acrylic-v2-480.webp?v=8",
    "theme": {
      "main": "#0e7490",
      "soft": "#cffafe",
      "warm": "#ecfeff"
    },
    "isV2": true,
    "isIntl": false,
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "candles-us",
    "baseId": "candles",
    "template": "candles",
    "name": "Hearth & Wick",
    "label": "Scented Candles · USA",
    "icon": "🇺🇸",
    "note": "Small-batch soy jar candles, pillars, sculpted candles and gift sets.",
    "business": "scented candles business in USA",
    "demo": "candles-us",
    "url": "https://candles-us.ownezzy.com",
    "pitch": "Sell scented candles online in USA",
    "preview": "https://ownezzy.com/previews/candles-us-480.webp?v=8",
    "theme": {
      "main": "#b45309",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "USA",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "jewelry-us",
    "baseId": "artjewellery",
    "template": "artjewellery",
    "name": "Willow & Bead",
    "label": "Handmade Jewelry · USA",
    "icon": "🇺🇸",
    "note": "Handmade earrings, beaded necklaces, bracelets, rings and anklets.",
    "business": "handmade jewelry business in USA",
    "demo": "jewelry-us",
    "url": "https://jewelry-us.ownezzy.com",
    "pitch": "Sell handmade jewelry online in USA",
    "preview": "https://ownezzy.com/previews/jewelry-us-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "USA",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "beauty-us",
    "baseId": "cosmetics",
    "template": "cosmetics",
    "name": "Glow Theory",
    "label": "Makeup & Skincare · USA",
    "icon": "🇺🇸",
    "note": "Cruelty-free lipsticks, foundations, palettes, nail colours and serums.",
    "business": "makeup & skincare business in USA",
    "demo": "beauty-us",
    "url": "https://beauty-us.ownezzy.com",
    "pitch": "Sell makeup & skincare online in USA",
    "preview": "https://ownezzy.com/previews/beauty-us-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "USA",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tees-us",
    "baseId": "tshirts",
    "template": "tshirts",
    "name": "Printwave Co.",
    "label": "Print-on-Demand Tees · USA",
    "icon": "🇺🇸",
    "note": "Graphic tees, kids tees and matching family shirts printed on demand.",
    "business": "print-on-demand tees business in USA",
    "demo": "tees-us",
    "url": "https://tees-us.ownezzy.com",
    "pitch": "Sell print-on-demand tees online in USA",
    "preview": "https://ownezzy.com/previews/tees-us-480.webp?v=8",
    "theme": {
      "main": "#2563eb",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "USA",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "botanicals-us",
    "baseId": "herbal",
    "template": "herbal",
    "name": "Rooted Botanicals",
    "label": "Herbal Hair & Skin Care · USA",
    "icon": "🇺🇸",
    "note": "Herbal hair oils, scalp serums, clay masks and body oils.",
    "business": "herbal hair & skin care business in USA",
    "demo": "botanicals-us",
    "url": "https://botanicals-us.ownezzy.com",
    "pitch": "Sell herbal hair & skin care online in USA",
    "preview": "https://ownezzy.com/previews/botanicals-us-480.webp?v=8",
    "theme": {
      "main": "#15803d",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "USA",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "bakery-ca",
    "baseId": "bakery",
    "template": "bakery",
    "name": "Maple Crumb Bakery",
    "label": "Home Bakery & Custom Cakes · Canada",
    "icon": "🇨🇦",
    "note": "Custom birthday, theme and wedding cakes, cupcakes and cookies.",
    "business": "home bakery & custom cakes business in Canada",
    "demo": "bakery-ca",
    "url": "https://bakery-ca.ownezzy.com",
    "pitch": "Sell home bakery & custom cakes online in Canada",
    "preview": "https://ownezzy.com/previews/bakery-ca-480.webp?v=8",
    "theme": {
      "main": "#db2777",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Canada",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "pets-ca",
    "baseId": "pets",
    "template": "pets",
    "name": "Maple Paws",
    "label": "Pet Food & Treats · Canada",
    "icon": "🇨🇦",
    "note": "Natural treats, food, toys and grooming for dogs, cats, birds and fish.",
    "business": "pet food & treats business in Canada",
    "demo": "pets-ca",
    "url": "https://pets-ca.ownezzy.com",
    "pitch": "Sell pet food & treats online in Canada",
    "preview": "https://ownezzy.com/previews/pets-ca-480.webp?v=8",
    "theme": {
      "main": "#ca8a04",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Canada",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "tea-ca",
    "baseId": "teacoffee",
    "template": "teacoffee",
    "name": "Brew North",
    "label": "Tea, Chai & Coffee · Canada",
    "icon": "🇨🇦",
    "note": "Loose leaf teas, chai blends, fresh-roasted coffee and brewing gear.",
    "business": "tea, chai & coffee business in Canada",
    "demo": "tea-ca",
    "url": "https://tea-ca.ownezzy.com",
    "pitch": "Sell tea, chai & coffee online in Canada",
    "preview": "https://ownezzy.com/previews/tea-ca-480.webp?v=8",
    "theme": {
      "main": "#7c2d12",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Canada",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "soaps-uk",
    "baseId": "selfcare",
    "template": "selfcare",
    "name": "Lather & Leaf",
    "label": "Handmade Soaps & Bath · United Kingdom",
    "icon": "🇬🇧",
    "note": "Cold-process soaps, bath bombs, body butters and spa gift sets.",
    "business": "handmade soaps & bath business in United Kingdom",
    "demo": "soaps-uk",
    "url": "https://soaps-uk.ownezzy.com",
    "pitch": "Sell handmade soaps & bath online in United Kingdom",
    "preview": "https://ownezzy.com/previews/soaps-uk-480.webp?v=8",
    "theme": {
      "main": "#0f766e",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "United Kingdom",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "gifts-uk",
    "baseId": "gifts",
    "template": "gifts",
    "name": "Keepsake Lane",
    "label": "Personalised Gifts & Hampers · United Kingdom",
    "icon": "🇬🇧",
    "note": "Personalised gifts, hampers, flowers and chocolates with next-day delivery.",
    "business": "personalised gifts & hampers business in United Kingdom",
    "demo": "gifts-uk",
    "url": "https://gifts-uk.ownezzy.com",
    "pitch": "Sell personalised gifts & hampers online in United Kingdom",
    "preview": "https://ownezzy.com/previews/gifts-uk-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "United Kingdom",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "crochet-de",
    "baseId": "crochet",
    "template": "crochet",
    "name": "Maschewerk",
    "label": "Crochet Flowers & Amigurumi · Germany",
    "icon": "🇩🇪",
    "note": "Crochet bouquets that never wilt, amigurumi plushies and crochet bags.",
    "business": "crochet flowers & amigurumi business in Germany",
    "demo": "crochet-de",
    "url": "https://crochet-de.ownezzy.com",
    "pitch": "Sell crochet flowers & amigurumi online in Germany",
    "preview": "https://ownezzy.com/previews/crochet-de-480.webp?v=8",
    "theme": {
      "main": "#7c3aed",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Germany",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "decor-nl",
    "baseId": "decor",
    "template": "decor",
    "name": "Nordic Nest",
    "label": "Scandi Home Decor · Netherlands",
    "icon": "🇳🇱",
    "note": "Soy candles, studio ceramics, mugs, rattan decor and diffusers.",
    "business": "scandi home decor business in Netherlands",
    "demo": "decor-nl",
    "url": "https://decor-nl.ownezzy.com",
    "pitch": "Sell scandi home decor online in Netherlands",
    "preview": "https://ownezzy.com/previews/decor-nl-480.webp?v=8",
    "theme": {
      "main": "#a16207",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Netherlands",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "plants-nl",
    "baseId": "plants",
    "template": "plants",
    "name": "Tulip Green",
    "label": "Plants & Orchids · Netherlands",
    "icon": "🇳🇱",
    "note": "Indoor plants, succulents, orchids and flowering plants grown in Holland.",
    "business": "plants & orchids business in Netherlands",
    "demo": "plants-nl",
    "url": "https://plants-nl.ownezzy.com",
    "pitch": "Sell plants & orchids online in Netherlands",
    "preview": "https://ownezzy.com/previews/plants-nl-480.webp?v=8",
    "theme": {
      "main": "#15803d",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Netherlands",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "comics-jp",
    "baseId": "comics",
    "template": "comics",
    "name": "Tokyo Panel",
    "label": "Comics, Manga & Figures · Japan",
    "icon": "🇯🇵",
    "note": "US comics, manga, graphic novels and collectible figures, new and pre-loved.",
    "business": "comics, manga & figures business in Japan",
    "demo": "comics-jp",
    "url": "https://comics-jp.ownezzy.com",
    "pitch": "Sell comics, manga & figures online in Japan",
    "preview": "https://ownezzy.com/previews/comics-jp-480.webp?v=8",
    "theme": {
      "main": "#dc2626",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Japan",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "resin-ae",
    "baseId": "resin",
    "template": "resin",
    "name": "Forever Petals",
    "label": "Resin Art & Flower Preservation · UAE",
    "icon": "🇦🇪",
    "note": "Wedding flowers preserved in resin, resin jewellery, coasters and wall art.",
    "business": "resin art & flower preservation business in UAE",
    "demo": "resin-ae",
    "url": "https://resin-ae.ownezzy.com",
    "pitch": "Sell resin art & flower preservation online in UAE",
    "preview": "https://ownezzy.com/previews/resin-ae-480.webp?v=8",
    "theme": {
      "main": "#d06b32",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "UAE",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "perfume-ae",
    "baseId": "perfume",
    "template": "perfume",
    "name": "Oud & Amber",
    "label": "Oud Perfumes & Attars · UAE",
    "icon": "🇦🇪",
    "note": "Oud perfumes, attars and gift sets for Eid, weddings and guests.",
    "business": "oud perfumes & attars business in UAE",
    "demo": "perfume-ae",
    "url": "https://perfume-ae.ownezzy.com",
    "pitch": "Sell oud perfumes & attars online in UAE",
    "preview": "https://ownezzy.com/previews/perfume-ae-480.webp?v=8",
    "theme": {
      "main": "#7c2d12",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "UAE",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "kitchen-ae",
    "baseId": "tiffin",
    "template": "tiffin",
    "name": "Dubai Home Kitchen",
    "label": "Home Food & Tiffin · UAE",
    "icon": "🇦🇪",
    "note": "Home-cooked dosa, meals, biryani, office lunch plans and catering.",
    "business": "home food & tiffin business in UAE",
    "demo": "kitchen-ae",
    "url": "https://kitchen-ae.ownezzy.com",
    "pitch": "Sell home food & tiffin online in UAE",
    "preview": "https://ownezzy.com/previews/kitchen-ae-480.webp?v=8",
    "theme": {
      "main": "#c2410c",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "UAE",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "favors-ae",
    "baseId": "favors",
    "template": "favors",
    "name": "Celebrate Favors",
    "label": "Party & Wedding Favours · UAE",
    "icon": "🇦🇪",
    "note": "Favour bags, gift boxes and hampers for weddings, baby showers and Eid.",
    "business": "party & wedding favours business in UAE",
    "demo": "favors-ae",
    "url": "https://favors-ae.ownezzy.com",
    "pitch": "Sell party & wedding favours online in UAE",
    "preview": "https://ownezzy.com/previews/favors-ae-480.webp?v=8",
    "theme": {
      "main": "#be185d",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "UAE",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "dates-sa",
    "baseId": "dryfruits",
    "template": "dryfruits",
    "name": "Dates & Delights",
    "label": "Dates, Nuts & Gift Boxes · Saudi Arabia",
    "icon": "🇸🇦",
    "note": "Medjool, Ajwa and Khudri dates, nuts and Ramadan gift boxes.",
    "business": "dates, nuts & gift boxes business in Saudi Arabia",
    "demo": "dates-sa",
    "url": "https://dates-sa.ownezzy.com",
    "pitch": "Sell dates, nuts & gift boxes online in Saudi Arabia",
    "preview": "https://ownezzy.com/previews/dates-sa-480.webp?v=8",
    "theme": {
      "main": "#92400e",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Saudi Arabia",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  },
  {
    "id": "toys-au",
    "baseId": "toys",
    "template": "toys",
    "name": "Little Wombat Toys",
    "label": "Toys & Ride-ons · Australia",
    "icon": "🇦🇺",
    "note": "Teddies, wooden toys, puzzles, dolls and ride-ons for kids.",
    "business": "toys & ride-ons business in Australia",
    "demo": "toys-au",
    "url": "https://toys-au.ownezzy.com",
    "pitch": "Sell toys & ride-ons online in Australia",
    "preview": "https://ownezzy.com/previews/toys-au-480.webp?v=8",
    "theme": {
      "main": "#2563eb",
      "soft": "#f5f3ff",
      "warm": "#fff7ed"
    },
    "isV2": false,
    "isIntl": true,
    "country": "Australia",
    "price": 399,
    "priceText": "₹399 / mo",
    "trialText": "7-Day Free Trial",
    "commission": "0%"
  }
];
